import { useEffect } from "react";

const SITE_ORIGIN = "https://www.studiopsicologiapaoletti.it";

// Aggiorna title, meta description e canonical per pagina (SPA).
export function useSeo(title, description, path) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }

    const canonicalPath = path || window.location.pathname;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${SITE_ORIGIN}${canonicalPath}`);

    // Allinea og:url e og:title/description dinamicamente.
    const setProp = (prop, content) => {
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", prop);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setProp("og:url", `${SITE_ORIGIN}${canonicalPath}`);
    if (title) setProp("og:title", title);
    if (description) setProp("og:description", description);
  }, [title, description, path]);
}
